import { Avatar } from "primereact/avatar";
import { useEffect } from "react";
import { ImQuotesLeft } from "react-icons/im";
const RecomCard = ({ quote, img, name, url, username, alt, role }) => {
  const formattedName = name.replace(/\s/g, "");

  //Set background image

  useEffect(() => {
    // const cardElt = document.querySelector(`.${formattedName}`);
    // cardElt.style.backgroundImage = `url('${img}')`;
  }, [formattedName, img]);

  return (
    <div
      className={[`  ${formattedName} bg-cover`]}
      style={{
        backgroundImage: `url('${img}')`,
      }}
    >
      <div className="rounded-xl flex flex-col justify-between lg:w-96 h-[28em] p-4 bg-[rgb(0,0,0,0.8)] backdrop-blur-md">
        <p className="py-4">
          <ImQuotesLeft size={"2.5em"} color="#fff" />
        </p>
        <p className="font-Roboto text-xl text-white">{quote}</p>
        <div className="flex pt-8">
          <div className="rounded-lg h-fit w-fit flex justify-center items-center overflow-hidden">
            <Avatar image={img} size="xlarge" className="rounded-lg" />
          </div>{" "}
          <div className="flex flex-col text-white justify-center ml-4">
            <div className="font-Montserrat">{name}</div>
            <div className="font-Montserrat">{role}</div>
            <a
              href={url}
              className="hover:text-blue-500 font-Montserrat"
              target="_blank"
              rel="noreferrer"
            >
              @{username}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecomCard;
